export default __webpack_public_path__ + "static/media/routinely1.8882af31.png";